import * as React from 'react';
import { ICardRecurringFormContext } from './types';

export const CardRecurringFormContext = React.createContext<ICardRecurringFormContext>(null);
